import { usePromotion } from "../hooks/usePromotion";

const Unit = ({ value, label, large }) => (
  <div
    className={`flex flex-col items-center rounded-xl border bg-white shadow-sm ${
      large
        ? "min-w-[4.4rem] border-[#FFB3DA] px-3 py-2.5 sm:min-w-[5.2rem] sm:py-3"
        : "min-w-[3.4rem] border-[#EAE6F0] px-2 py-1.5"
    }`}
  >
    <span
      className={`font-extrabold tabular-nums leading-none text-[#242344] ${
        large ? "text-3xl sm:text-4xl" : "text-xl sm:text-2xl"
      }`}
    >
      {String(value).padStart(2, "0")}
    </span>
    <span
      className={`mt-1 font-semibold uppercase tracking-wide text-[#68677A] ${
        large ? "text-xs sm:text-sm" : "text-[0.65rem]"
      }`}
    >
      {label}
    </span>
  </div>
);

export default function Countdown({ size = "default" }) {
  const { active, days, hours, minutes, seconds } = usePromotion();
  if (!active) return null;
  const large = size === "lg";
  return (
    <div data-testid="countdown-timer" className="inline-block">
      <div className={`flex ${large ? "gap-2.5 sm:gap-3" : "gap-2"}`} aria-hidden="true">
        <Unit value={days} label="dni" large={large} />
        <Unit value={hours} label="godz." large={large} />
        <Unit value={minutes} label="min" large={large} />
        <Unit value={seconds} label="sek" large={large} />
      </div>
      <span className="sr-only">
        Do końca promocji pozostało: {days} dni, {hours} godzin, {minutes} minut.
      </span>
    </div>
  );
}
